import React from 'react';

import './emptyRow.scss';

export default ({text}) => {
    return (
        <div className={"empty-rows-table valign-wrapper"}>
            <p>{text}</p>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/EmptyRow/index.js